<template>
  <sparkline
    :id="id"
    :options="options"
    :color="color"
    :value="`${value}%`"
    :year="`${year} grads`"
    title="First-time bar pass rates"
    :url="url"
    :help="terms.firstTimeBarPassRate"
  />
</template>

<script setup>
import Sparkline from "@/components/sparklines/Sparkline.vue"
import colors from "@/colors"
import route from "ziggy-js"
import terms from "@/terms"
import { computed, ref } from "vue"

const props = defineProps({
  school: { type: Object, required: true },
})

const id = computed(() => `${props.school.slug}-first-time-bar-pass-rates`)
const url = computed(() => route("schools.bar", props.school.slug))
const data = computed(() => (props.school.first_time_bar_pass_rates ? Object.values(props.school.first_time_bar_pass_rates[props.school.id]) : []))

const firstYear = computed(() => data.value[0].year)
const latestYear = computed(() => data.value[data.value.length - 1].year)
const value = ref(data.value[data.value.length - 1].rate)
const year = ref(latestYear.value)
const color = colors.teal[500]

const options = computed(() => {
  const series = [{
    type: "areaspline",
    data: data.value.map((item) => item.rate),
    point: {
      events: {
        mouseOver() {
          value.value = this.y
          year.value = this.x + firstYear.value
        },
        mouseOut() {
          year.value = latestYear.value
          value.value = data.value[data.value.length - 1].rate
        },
      },
    },
  }]

  return {
    series,
  }
})
</script>
